export interface DeleteQuizResponse {
  success: boolean;
  message: string;
}

export interface QuizGridRow {
  quizid: number;
  description: string;
  passscore: number;
  isactive: boolean;
}

export interface IQuiz {
  quizid: number;
  description: string;
  passscore: number;
  isactive: boolean;
}

export function isQuizGridRow(data: any): data is QuizGridRow {
  return (
    typeof data === 'object' &&
    data !== null &&
    "quizid" in data &&
    typeof data["quizid"] === "number" &&
    "description" in data &&
    typeof data["description"] === "string" &&
    "passscore" in data &&
    typeof data["passscore"] === "number" &&
    "isactive" in data &&
    typeof data["isactive"] === "boolean"
  );
}

export class QuizClass {
  quizid: number;
  description: string;
  passscore: number;
  isactive: boolean;
  quizquestion: Array<QuizQuestionClass>;
  constructor() {
    this.quizid = null;
    this.description = null;
    this.passscore = null;
    this.isactive = true;
    this.quizquestion = [];
  }
}

export class QuizQuestionClass {
  quizid: number;
  quizquestionid: number;
  description: string;
  questiontypeid: number;
  quizanswer: Array<QuizAnswerClass>;
  constructor() {
    this.quizid = null;
    this.quizquestionid = null;
    this.description = null;
    this.questiontypeid = 1;
    this.quizanswer = [];
  }
}

export class QuizAnswerClass {
  quizanswerid: number;
  quizquestionid: number;
  description: string;
  iscorrect: boolean;
  constructor() {
    this.quizanswerid = null;
    this.quizquestionid = null;
    this.description = null;
    this.iscorrect = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/quiz/quiz.class.ts